import React, { Component } from 'react'
import styles from './Invitation404Form.module.scss';
import classNames from 'classnames/bind';

import {Header, SubHeader, ContactUsText, AwairLogo} from '../../atoms';
import { invitation404FormContentsEn, invitation404FormContentsKr } from '../../../assets/contents/invitation-404-form';

const cx = classNames.bind(styles);

class Invitation404Form extends Component {
  render() {
    const {language} = this.props;
    const textContents = language === 'ko' ? invitation404FormContentsKr : invitation404FormContentsEn;
    const {
      header,
      headerDescription,
      contactUsDescription
    } = textContents;
    return (
      <div>
        <AwairLogo />
        <div className={cx('Invitation404Form')}>
          <Header text={header} />
          <SubHeader text={headerDescription}/>
        </div>
        <ContactUsText className={cx('Invitation404Form__contact-us')} text={contactUsDescription} mailLink='hello@getawair.com'/>
      </div>
    )
  }
}

export default Invitation404Form;